export function moveUnifeFooter() {
  const unifeFooter = document.getElementById("unife-footer");
  const portalFooter = document.getElementById("portal-footer-wrapper");

  if (unifeFooter && portalFooter) {
    const copy = unifeFooter.cloneNode(true);
    portalFooter.appendChild(copy);
    unifeFooter.remove();
  }
}
